export default __webpack_public_path__ + "static/media/Sudarshan Kumar.13de8e71.png";